<template>
    <button :type="type"
            :disabled="disabled"
            class="inline-flex items-center py-2 px-4 border border-transparent text-xs uppercase tracking-widest font-semibold text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige focus:outline-none disabled:opacity-25 transition">
        <slot></slot>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    })
</script>
